import { useStoredCart } from "./storage.mjs";
import { resolveCartOptions } from "./utils.mjs";
import { CART } from "../../const/cookies.mjs";
import { MergeCartsDocument } from "../../graphql/MergeCart.mjs";
import { useAlerts } from "../alerts.mjs";
import { useMutation } from "villus";
import { useState, useCookie } from "#imports";
import { useI18n } from "#i18n";
function useMergingStore() {
  const isMergingCart = useState("is-merging-cart", () => false);
  return {
    isMergingCart
  };
}
export function useMergeCartItems() {
  const { isMergingCart } = useMergingStore();
  const { execute } = useMutation(MergeCartsDocument);
  const cartCookies = useCookie(CART);
  const { cartState, patchCartState, mapCartState } = useStoredCart();
  const { success, error: alertError } = useAlerts();
  const { t } = useI18n();
  async function mergeCartItems(sourceId) {
    try {
      if (isMergingCart.value) {
        throw new Error("cartIsMerging");
      }
      isMergingCart.value = true;
      const { data, error } = await execute({
        dest: cartState.value.cartId,
        source: sourceId,
        ...resolveCartOptions("mergeCart")
      });
      if (error) {
        throw new Error(error.message);
      }
      if (data?.response) {
        patchCartState(mapCartState(data.response));
        cartCookies.value = null;
      }
      success("success", "Cart items merged successfully");
    } catch (e) {
      console.log(e);
      if (/The cart isn't active\./.test(e.message)) {
        alertError("error", t("cartIsNotActive").toString());
        cartCookies.value = null;
      }
      if (/Could not find a cart with ID /.test(
        e.message
      )) {
        cartCookies.value = null;
      }
    } finally {
      isMergingCart.value = false;
    }
  }
  return {
    mergeCartItems
  };
}
